import React, { useCallback } from 'react';
import type { Command } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useTransformNavigationCommands } from '../../../utils/transform-navigation-commands/index.tsx';
import { IssueLeftIcon } from './issue-left-icon/index.tsx';
import { IssueView } from './issue-view/index.tsx';
import type { IssueCommandProps } from './types.tsx';

export const useGetIssueCommand = () => {
	const { transformNavigationCommand } = useTransformNavigationCommands();

	const getIssueCommand = useCallback(
		({ issue, keywords, section, analytics, ...rest }: IssueCommandProps): Command => {
			const { issueId, summary, issueKey, projectId = 'UNAVAILABLE' } = issue;
			return transformNavigationCommand(
				{
					id: `issue-${issueId}`,
					section,
					keywords,
					name: `${issueKey} ${summary}`,
					components: {
						Name: ({ isActive }) => <IssueView issue={issue} isActive={isActive} />,
						LeftIcon: () => (
							<IssueLeftIcon iconUrl={issue.avatar?.url} issueTypeName={issue.issueTypeName} />
						),
					},
					analytics: {
						action: 'issueViewed',
						issueId,
						metadata: {
							contentId: issueId,
							containerId: projectId,
							contentType: 'issue',
						},
						...analytics,
					},
					...rest,
				},
				{ path: `/browse/${issueKey}` },
			);
		},
		[transformNavigationCommand],
	);

	return { getIssueCommand };
};
